import axios from 'axios';
import {
    PRESET_FILTERS,
} from './utils/editor.constants';

export const getFullSequenceEmailReport = async (funnelId, startDate, endDate) => {
    const { data } = await axios.get(`/app/funnel/${funnelId}/reportFullSequenceEmailStats?startDate=${startDate}&endDate=${endDate}`);

    return data;
};

export const getEmailStats = async (funnelId, preset = PRESET_FILTERS.LAST_7_DAYS) => {
    const { data } = await axios.get(`/app/funnel/${funnelId}/getEmailStats?preset=${preset}`);

    return data;
};

export const getUniqueContactsStats = async (funnelId, preset = PRESET_FILTERS.LAST_7_DAYS) => {
    const { data } = await axios.get(`/app/funnel/${funnelId}/getUniqueContacts?preset=${preset}`);

    return data;
};

export const getDateRangeEmailStats = async (funnelId, startDate, endDate) => {
    const { data } = await axios.get(`/app/funnel/${funnelId}/getDateRangeEmailStats?startDate=${startDate}&endDate=${endDate}`);

    return data;
};

export const getDateRangeUniqueContactsStats = async (funnelId, startDate, endDate) => {
    const { data } = await axios.get(`/app/funnel/${funnelId}/getDateRangeUniqueContacts?startDate=${startDate}&endDate=${endDate}`);

    return data;
};

export const getDateRangeStats = async (funnelId, startDate, endDate) => {
    const { data: { nodeCounts } } = await axios.get(`${funnelId}/getDateRangeStats?startDate=${startDate}&endDate=${endDate}`);

    return { data: nodeCounts };
};

export const getFunnelStats = (funnelId, preset) => {
    return axios.get(`${funnelId}/getFunnelStats?preset=${preset}`);
};

export const getActiveStats = (funnelId) => {
    return axios.get(`${funnelId}/getActiveStats`);
};

export const fetchDraftXml = (funnelId) => {
    return axios.get(`/app/funnel/${funnelId}/xml`);
};

export const fetchPublishedXml = (funnelId) => {
    return axios.get(`/app/funnel/${funnelId}/publishedXml`);
};

export const getEnabledCellTypes = async () => {
    const { data } = await axios.get('/app/funnel/getEnabledCellTypesForApp');

    return data?.enabledCells;
};

export const getContactsInfoKonva = async (funnelId, pageToken, pageSize, xml) => {
    const { data } = await axios.post(`/app/funnel/contactsThatCanBeAddedToFunnel?funnelId=${funnelId}`, { xml, pageToken, pageSize });

    return data;
};

export const getEnabledIntegrations = async () => {
    const response = await axios
        .get('/app/funnel/getIntegrationsForApp');

    return response?.data?.sidebarIntegrations;
};

export const unlockEditor = async (funnelId, hashCode) => {
    const { data } = await axios.post(`/app/editorLockout/unlockFunnelEditor/${funnelId}/${hashCode}`);

    return data;
};

export const lockEditor = async (funnelId) => {
    const { data: { hash } } = await axios.post(`/app/editorLockout/lockFunnelEditor/${funnelId}`);

    return hash;
};

export const getAutomationLockStatus = async (funnelId) => {
    const { data } = await axios.get(`/app/editorLockout/funnelLockStatus/${funnelId}`);

    return data;
};

export const disableBetaFeatures = async (swap) => {
    return axios.put('/app/funnel/disable_beta_features', swap);
};

export const revertXml = async (revertToXml, draftXml, publishedXml) => {
    const payload = {
        revertToXml,
        draftXml,
        publishedXml,
    };

    await axios.put('/app/funnel/revert', payload);
};

export const unpublish = async (funnelId, unpublishedFormMessage) => {
    await axios.put(`/app/funnel/${funnelId}/unpublish`, unpublishedFormMessage);
};
